import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=76412705&scoped=true&lang=pug&"
import script from "./Branch.vue?vue&type=script&lang=ts&"
export * from "./Branch.vue?vue&type=script&lang=ts&"
import style0 from "./Branch.vue?vue&type=style&index=0&id=76412705&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76412705",
  null
  
)

export default component.exports